/**
 * created by lei lei
 * 图片上传
 */
import React, {Component} from 'react';
import {message, Modal} from "antd";
import "./PhotoUpload.scss"
import ImagesLocally from "../imagesLocally/ImagesLocally"

export default class PhotoUpload extends Component {

    constructor(props) {
        super(props);
        this.state = {
            uploadFileList: [],
        };
    }

    render() {
        const {photoUpload,handleOk,handleCancel} = this.props;
        const {uploadFileList} = this.state;
        return(
            <Modal
                title="本地上传"
                visible={photoUpload}
                onCancel={handleCancel}
                width={958}
                onOk={()=>{
                    let fileList = uploadFileList;
                    for(let i = 0 ; fileList && i < fileList.length; i++){
                        let item = fileList[i];
                        if(item.uid){//说明是刚上传的
                            if(item.status!="done"){
                                message.destroy()
                                message.warn({content: `图片尚未上传完成！`});
                                return;
                            }
                        }
                    }
                    if(this.imagesLocally){
                        fileList.map(file => {
                            file.float = this.imagesLocally.state.float;
                            file.cssWidth = this.imagesLocally.state.cssWidth;
                            file.cssMargin = this.imagesLocally.state.cssMargin;
                            file.cssBorder = this.imagesLocally.state.cssBorder;
                            file.cssWater = this.imagesLocally.state.cssWater;
                        })
                    }
                    handleOk(fileList)
                }}
                bodyStyle={{padding:0}}
                maskClosable={false}
            >
                    <div className="interval">
                        <ImagesLocally ref={imagesLocally=>this.imagesLocally=imagesLocally} onChange={(uploadFileList)=>{
                            this.setState({uploadFileList})
                        }} />
                    </div>
            </Modal>
        )
    }

}
